import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import { getFilenameFromContentDisposition } from "../../../helpers";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { IHabitationalApplication } from "./habitationalApplicationNew.types";
import { IDate } from "../../../components/Table/hooks/useDateFilter";

export const FETCH_HABITATIONAL_APPLICATION_LIST_PROGRESS =
  "FETCH_HABITATIONAL_APPLICATION_LIST_PROGRESS";
export const FETCH_HABITATIONAL_APPLICATION_LIST_SUCCESS =
  "FETCH_HABITATIONAL_APPLICATION_LIST_SUCCESS";
export const FETCH_HABITATIONAL_APPLICATION_LIST_FAILED =
  "FETCH_HABITATIONAL_APPLICATION_LIST_FAILED";

export const FETCH_HABITATIONAL_EDI_LIST_PROGRESS =
  "FETCH_HABITATIONAL_EDI_LIST_PROGRESS";
export const FETCH_HABITATIONAL_EDI_LIST_SUCCESS =
  "FETCH_HABITATIONAL_EDI_LIST_SUCCESS";
export const FETCH_HABITATIONAL_EDI_LIST_FAILED =
  "FETCH_HABITATIONAL_EDI_LIST_FAILED";

export const fetchHabitationalApplicationListProgress = () =>
  action(FETCH_HABITATIONAL_APPLICATION_LIST_PROGRESS);
export const fetchHabitationalApplicationListSuccess = (
  list: IHabitationalApplication[],
  totalRecords: number
) =>
  action(FETCH_HABITATIONAL_APPLICATION_LIST_SUCCESS, { list, totalRecords });
export const fetchHabitationalApplicationListFailed = () =>
  action(FETCH_HABITATIONAL_APPLICATION_LIST_FAILED);

export const fetchHabitationalApplicationListAsync =
  (customerPolicyId: number, status?: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchHabitationalApplicationListProgress());
      
      let finalUrl =  `/policy/get-policy-habitational-application?customer_policy_id=${customerPolicyId}`;

      if (status && status !== "-1") {
        finalUrl += "&status=" + status;
      }
      const res = await api.get(finalUrl);
      const data: IHabitationalApplication[] = res.data.data;
      const totalRecords = res.data.totalRecords;
      console.log("data from list view", data);
      dispatch(fetchHabitationalApplicationListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchHabitationalApplicationListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };



export const fetchHabitationalEDIListProgress = () =>
  action(FETCH_HABITATIONAL_EDI_LIST_PROGRESS);
export const fetchHabitationalEDIListSuccess = (
  list: IHabitationalApplication[],
  totalRecords: number
) =>
  action(FETCH_HABITATIONAL_EDI_LIST_SUCCESS, { list, totalRecords });
export const fetchHabitationalEDIListFailed = () =>
  action(FETCH_HABITATIONAL_EDI_LIST_FAILED);

export const fetchHabitationalEDIListAsync =
(
  pageNumber: number,
  rowsInPerPage: number,
  status: string | null,
  searchValue: string,
  searchType: string[],
  date: IDate,
): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchHabitationalEDIListProgress());
      let finalUrl = `/csio/get-csio-application-edi?table=Habitational&pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;

      if (searchType.length > 0 && searchValue) {
        finalUrl = `/csio/get-csio-application-edi?table=Habitational&pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&column=${[
          searchType,
        ]}&value=${searchValue}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      
      const res = await api.get(finalUrl);
      const data: IHabitationalApplication[] = res.data.data;
      const totalRecords = res.data.totalRecords;
      console.log("data from list view", data);
      dispatch(fetchHabitationalEDIListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchHabitationalEDIListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const FETCH_HABITATIONAL_APPLICATION_PROGRESS =
  "FETCH_HABITATIONAL_APPLICATION_PROGRESS";
export const FETCH_HABITATIONAL_APPLICATION_SUCCESSS =
  "FETCH_HABITATIONAL_APPLICATION_SUCCESSS";
export const FETCH_HABITATIONAL_APPLICATION_FAILED =
  "FETCH_HABITATIONAL_APPLICATION_FAILED";

export const fetchHabitationalApplicationProgress = () =>
  action(FETCH_HABITATIONAL_APPLICATION_PROGRESS);
export const fetchHabitationalApplicationSuccess = (
  data: IHabitationalApplication
) => action(FETCH_HABITATIONAL_APPLICATION_SUCCESSS, { data });
export const fetchHabitationalApplicationFailed = (error?: string) =>
  action(FETCH_HABITATIONAL_APPLICATION_FAILED, { error });

export const fetchHabitationalApplicationAsync =
  (
    customerPolicyId: number,
    IncrementalNumber: number
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchHabitationalApplicationProgress());
      const res = await api.get(
        `/policy/get-policy-habitational-application?customer_policy_id=${customerPolicyId}&column=incremental_number&value=${IncrementalNumber}`
      );

      const data: IHabitationalApplication[] = res.data.data;
      if (data.length > 0) {
        const firstElement: IHabitationalApplication = data[0];

        // Normalize coverage_discription (API typo) -> coverage_description
        if (firstElement.risk_location_data) {
          firstElement.risk_location_data = firstElement.risk_location_data.map(
            (location: any) => {
              if (location.coverages_form) {
                location.coverages_form = location.coverages_form.map(
                  (coverage: any) => {
                    if (
                      coverage.coverage_description === undefined &&
                      coverage.coverage_discription !== undefined
                    ) {
                      const { coverage_discription, ...rest } = coverage;
                      return {
                        ...rest,
                        coverage_description: coverage_discription,
                      };
                    }
                    return coverage;
                  }
                );
              }
              return location;
            }
          );
        }

        dispatch(fetchHabitationalApplicationSuccess(firstElement));
      } else {
        dispatch(
          fetchHabitationalApplicationFailed(
            "Unfortunately, there are no records available at the moment."
          )
        );
      }
    } catch (err: any) {
      dispatch(fetchHabitationalApplicationFailed("Some error occured"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addHabitationalApplication =
  (
    data: IHabitationalApplication,
    customerPolicyId: number,
    onCallback: (isSuccess: boolean, incrementalNumber?: number | null) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const res = await api.post("/policy/create-policy-habitational-application", {
        ...data,
        customer_policy_id: customerPolicyId,
      });
      const returnedIncrementalNumber = res.data.data?.incremental_number ?? null;
      onCallback(true, returnedIncrementalNumber);
      dispatch(
        showMessage({
          type: "success",
          message: "Habitational application data saved successfully!",
          displayAs: "snackbar",
        })
      );
      dispatch(fetchHabitationalApplicationSuccess(data));
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };


  export const downloadHabitationalPDFApplications =
  (
    customerPolicyId: number,
    incremental_number: number
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const res = await api.get(
        `/policy/get-habitational-application-pdf?customer_policy_id=${customerPolicyId}&incremental_number=${incremental_number}`,
        {
          responseType: "arraybuffer",
        }
      );

      const pdfBuffer = res.data;

      const pdfBlob = new Blob([pdfBuffer], { type: "application/pdf" });

      const pdfUrl = URL.createObjectURL(pdfBlob);

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = getFilenameFromContentDisposition(res);
      link.click();

      URL.revokeObjectURL(pdfUrl);
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };
export const previewHabitationalPDFApplications =
  (
    customerPolicyId: number,
    incremental_number: number
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const res = await api.get(
        `/policy/get-habitational-application-pdf?customer_policy_id=${customerPolicyId}&incremental_number=${incremental_number}&is_habitational_application_preview=true`
      );

      for (const key in res.data.data) {
        const newTab = window.open("", "_blank");
        if (newTab) {
          newTab.document.write(res.data.data[key]);
          newTab.document.close();
        }
      }
    } catch (err: any) {
      // dispatch(fetchCommAutomobileLiabilitySlipsListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };


import { ITemplateField } from "../../CustomFormFields/CustomFormFields.types";

export const fetchHabitationalApplicationDynamicForms =
  (
    customerPolicyId: number,
    applicationId: number,
    onCallback: (isSuccess: boolean, data: any[]) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await api.get(
        `/policy/get-application?customer_policy_id=${customerPolicyId}&application_id=${applicationId}`
      );
      const data = res.data.data;
      onCallback(true, data);
    } catch (err: any) {
      onCallback(false, []);
    }
  };

export const upsertHabitationalApplicationDynamicForms =
  (
    data: {
      incremental_number: number | null;
      policy_habitational_application_code: string | null;
      customer_policy_id: number;
      application_id: number;
      fields: ITemplateField[];
      status: string;
    },
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post("/policy/upsert-application", data);
      onCallback(true);
      dispatch(
        showMessage({
          type: "success",
          message: "Dynamic form saved successfully!",
          displayAs: "snackbar",
        })
      );
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const fetchHabitationalApplicationDynamicFormsByLeadId =
  (
    leadId: string,
    incrementalNumber: number,
    onCallback: (isSuccess: boolean, data: any[]) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      let url: string;
      if (leadId) {
        url = `/lead/get-lead-habitational-application?lead_id=${leadId}&incremental_number=${incrementalNumber}`;
      } else {
        url = `/policy/get-application?lead_id=${leadId}&application_id=${incrementalNumber}`;
      }
      const res = await api.get(url);
      const data = res.data.data;
      onCallback(true, data);
    } catch (err: any) {
      onCallback(false, []);
    }
  };

export const upsertHabitationalApplicationDynamicFormsByLeadId =
  (
    data: {
      incremental_number: number | null;
      policy_habitational_application_code: string | null;
      lead_id: string;
      fields: ITemplateField[];
      status: string;
    },
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(saveLoaderProgress());
      let url: string;
      let payload: any;
      if (data.lead_id) {
        url = "/lead/upsert-lead-habitational-application";
        const { incremental_number, ...rest } = data;
        payload = {
          ...rest,
          ...(incremental_number ? { incremental_number } : {}),
        };
      } else {
        url = "/policy/upsert-application";
        payload = data;
      }
      await api.post(url, payload);
      onCallback(true);
      dispatch(
        showMessage({
          type: "success",
          message: "Dynamic form saved successfully!",
          displayAs: "snackbar",
        })
      );
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_HABITATIONAL_APPLICATION_STATE =
  "CLEAR_HABITATIONAL_APPLICATION_STATE";
export const clearHabitationalApplicationState = () =>
  action(CLEAR_HABITATIONAL_APPLICATION_STATE);
